import { highlightMatches } from './highlight'

const DEFAULT_ROLE_LABELS = { user: 'You', assistant: 'Assistant' }

function formatTime(value) {
  if (!value) return ''
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return ''
  return d.toLocaleString([], {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  })
}

// Generic results panel for a chat search. Each result is { _id, role,
// createdAt, snippet }. Clicking one calls onSelect(id). `roleLabels` maps a
// role to a display name so this stays reusable across chat types.
function SearchResults({ results, query, loading, error, ran, onSelect, roleLabels = DEFAULT_ROLE_LABELS }) {
  let body
  if (loading) {
    body = <div className="chat-search-empty">Searching…</div>
  } else if (error) {
    body = <div className="chat-search-empty chat-search-error">{error}</div>
  } else if (ran && results.length === 0) {
    body = <div className="chat-search-empty">No matches.</div>
  } else if (results.length > 0) {
    body = (
      <ul className="chat-search-list">
        {results.map((r) => (
          <li key={r._id}>
            <button type="button" className="chat-search-item" onClick={() => onSelect(r._id)}>
              <span className="chat-search-item-head">
                <span className="chat-search-role">{roleLabels[r.role] || r.role}</span>
                <span className="chat-search-time">{formatTime(r.createdAt)}</span>
              </span>
              <span className="chat-search-snippet">{highlightMatches(r.snippet, query)}</span>
            </button>
          </li>
        ))}
      </ul>
    )
  } else {
    body = <div className="chat-search-empty">Type to search this conversation.</div>
  }

  return <div className="chat-search-results">{body}</div>
}

export default SearchResults
